























import Vue from 'vue';
import { MenuItem } from '@/store/types';
export default Vue.extend({
  name: 'SideBar',
  components: {},
  props: {
    menuItems: {
      type: Array as () => MenuItem[]
    },
    barState: {
      type: Boolean
    },
    value: {
      type: Boolean
    },
    right: {
      type: Boolean
    }
  },
  computed: {
    test() {
      return this.menuItems;
    }
  },
  methods: {
    routeTo(path: string) {
      this.$router.push(path);
    },
    routeToSection(basePath: string, sectionId?: string) {
      if (!sectionId) {
        this.routeTo(basePath);
      } else {
        const path = `${basePath}#${sectionId}`;
        this.$router.push({ path: path });
      }
    },
    setValue(value: boolean) {
      this.$emit('input', value);
    }
  }
});
